// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"bf2a9a74","816":"21aed134"}[chunkId] + ".chunk.js";
};